export const VARIANTS = ['v1', 'v2', 'v3'] as const
export type VariantId = (typeof VARIANTS)[number]
export const DEFAULT_VARIANT: VariantId = 'v1'
const KEY = 'sauiv2:variant'

const isVariant = (v: string | null | undefined): v is VariantId => !!v && (VARIANTS as readonly string[]).includes(v)

export function getActiveVariant(search = ''): VariantId {
  const fromUrl = new URLSearchParams(search).get('variant')
  if (isVariant(fromUrl)) return fromUrl
  try {
    const stored = globalThis.localStorage?.getItem(KEY)
    if (isVariant(stored)) return stored
  } catch {
    /* storage blocked */
  }
  return DEFAULT_VARIANT
}

export function setActiveVariant(id: string): void {
  if (!isVariant(id)) return
  try {
    globalThis.localStorage?.setItem(KEY, id)
  } catch {
    /* storage blocked */
  }
}
